import React from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { Dropdown, DropdownItem } from "reactstrap";
import { CustomizationColors, IconDispatcher } from "shared/ui-basics/index";
import * as Style from "./style";
import TaxonomyItem from "features/taxonomy/components/TaxonomyItem";

export default function Priority({ object, setObject, name, disable, updateFunction }) {
	const { t } = useTranslation();
	const allPriorities = useSelector((state) => state.libraries.priority);
	const entityPriorities = allPriorities && allPriorities[name];
	const [togglePriority, setTogglePriority] = React.useState(false);
	const selected = getSelected(entityPriorities, object);
	const showPlaceHolder = Object.keys(selected)?.length === 0;

	const handlePriority = (e) => {
		const id = e.currentTarget.id;
		const updatedObject = { ...object, priorityId: id };
		setObject && setObject(updatedObject);
		if (updateFunction) {
			updateFunction(updatedObject, ["priorityId"]);
		}
	};
	const { color, backgroundColor } = CustomizationColors[selected?.colorCode] || { color: "#333", backgroundColor: selected?.colorCode };

	return (
		<>
			{entityPriorities && (
				<Dropdown className="w-100" isOpen={togglePriority} toggle={() => setTogglePriority(!togglePriority)} direction="down" disabled={disable}>
					<Style.ToggleCaret className="w-100" disabled={disable}>
						{showPlaceHolder ? (
							<div>{t("NO_PRIORITY")}</div>
						) : (
							<>
								<TaxonomyItem text={selected.name} color={color} backgroundColor={backgroundColor} />
								{togglePriority && <div className="caret">{IconDispatcher("ANGLE-UP")}</div>}
								{!togglePriority && <div className="caret">{IconDispatcher("ANGLE-DOWN")}</div>}
							</>
						)}
					</Style.ToggleCaret>
					<Style.MenuDrop className="p-3">
						{entityPriorities?.map((priority) => {
							const { color, backgroundColor } = CustomizationColors[priority?.colorCode] || { color: "#333", backgroundColor: priority?.colorCode };
							return (
								<DropdownItem key={priority?.id} id={priority?.id} onClick={handlePriority} className="mb-1">
									<TaxonomyItem text={priority.name} color={color} backgroundColor={backgroundColor} />
								</DropdownItem>
							);
						})}
					</Style.MenuDrop>
				</Dropdown>
			)}
		</>
	);
}

const getSelected = (priority, object) => {
	if (priority?.length > 0) {
		const found = priority?.find((prio) => prio.id === object?.priorityId);
		if (found) return found;
		return priority[0];
	}
	return {};
};
